import { render } from "./TicketSingle.vue?vue&type=template&id=28a9dbcc&scoped=true"
import script from "./TicketSingle.vue?vue&type=script&lang=js"
export * from "./TicketSingle.vue?vue&type=script&lang=js"

import "./TicketSingle.vue?vue&type=style&index=0&id=28a9dbcc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a9dbcc"]])

export default __exports__